import { USER_NOTIFICATIONS_GET } from '../actions/types';

const initialState = {
  items: [],
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case USER_NOTIFICATIONS_GET._SUCCESS: {
      const { notifications } = action.payload;
      state.items = notifications;
      return state;
    }
    default:
      return state;
  }
};

export { reducer as notifications };
